// extracted by mini-css-extract-plugin
export var formGroup = "newsletter-module--form-group--98e1f";